import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

function pltcap() {
    const PLCboxes = document.querySelectorAll('[data-target="plc_box"]');
    if (!PLCboxes) { return; }

    const plc_box_wrap = document.querySelector('[data-target="plc_box_wrap"]');
    
    PLCboxes.forEach(function(PLCbox) {
       
            const iButton = PLCbox.querySelector('[data-target="i_button"]');
            const gOpacity = PLCbox.querySelector('[data-target="g_opacity"]');

            const h3 = PLCbox.querySelector('h3');
            const tooltip = PLCbox.querySelector('[data-target="tooltip"]');
            const taxonomy_txt = PLCbox.querySelector('[data-target="taxonomy_txt"]');
            
            let tl, tlback;

            let isActive = false;

            const showTooltip = () => {
                if (tlback && tlback.isActive()) {
                    tlback.kill();
                }

                tl = gsap.timeline();
                tl.to([h3, taxonomy_txt], {autoAlpha: 0, duration: 0.5}, "start")
                  .to(gOpacity, {fillOpacity: 1, duration: 0.5}, "start")
                  .to(tooltip, {autoAlpha: 1, duration: 0.3});
            };

            const hideTooltip = () => {
                if (tl && tl.isActive()) {
                    tl.kill();
                }

                tlback = gsap.timeline();
                tlback.to(tooltip, {autoAlpha: 0, duration: 0.3}, "start")
                      .to(gOpacity, {fillOpacity: 0.2, duration: 0.5}, "start")
                      .to([h3, taxonomy_txt], {autoAlpha: 1, duration: 0.5});
            };

            const toggleTooltip = () => {
                isActive = !isActive;
                if (isActive) {
                    showTooltip();
                } else {
                    hideTooltip();
                }
            };

            if (window.innerWidth < 768) {
                iButton.addEventListener('click', toggleTooltip);
            } else {
                iButton.addEventListener('mouseover', showTooltip);
                iButton.addEventListener('mouseout', hideTooltip);
            }

            window.addEventListener('resize', () => {
                iButton.removeEventListener('click', toggleTooltip);
                iButton.removeEventListener('mouseover', showTooltip);
                iButton.removeEventListener('mouseout', hideTooltip);

                if (window.innerWidth < 768) {
                    iButton.addEventListener('click', toggleTooltip);
                } else {
                    iButton.addEventListener('mouseover', showTooltip);
                    iButton.addEventListener('mouseout', hideTooltip);
                }
            });



           
                

        
    });
    

    gsap.from(PLCboxes, {
        autoAlpha: 0,
        duration: 1,
        //stagger:0.2,
        scrollTrigger: {
        trigger: plc_box_wrap,
         start:'top 70%'
        
        },
    });
    
}


export { pltcap }; 